console.log('js/url.js -> v0.1.0');

function getQueryStringParameterByName(uri, name) {
	name = name.replace(/[\[\]]/g, "\\$&");
	var re = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
	var results = re.exec(uri);

	if (!results)
		return null;
	if (!results[2])
		return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}


function updateQueryStringParameter(uri, key, value) {
	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	if (uri.match(re)) {
		return uri.replace(re, '$1' + key + "=" + value + '$2');
	} else {
		return uri + separator + key + "=" + value;
	}
};


function addQueryStringParameter(uri, key, value) {
	var frags = uri.split("#");
	var base = frags[0];
	var anchor = frags.length > 1 ? "#" + frags[1] : "";
	var separator = base.indexOf('?') !== -1 ? "&" : "?";
	return base + separator + key + "=" + value + anchor;
}

function removeQueryStringParameter(uri, key, value) {
	var frags = uri.split("?");
	var base = frags[0];

	if (frags.length > 1) {
		frags = frags[1].split("#");
		var anchor = frags.length > 1 ? frags[1] : "";
		var params = frags[0].split("&");
		for (var i = 0; i < params.length; ) {
			var paramValue = params[i].split("=");
			if (paramValue[0] === key && (value === undefined || paramValue[1] == value ) ) {
				params.splice(i, 1);
			} else {
				++i;
			}
		}
		if (params.length)
			base = base + "?" + params.join("&");
		if (anchor.length)
			base += "#" + anchor;
	}
	return base;
}


function removeHost(url) {
	var proto = url.indexOf('://');
	if (proto != -1)
		url = url.substring(proto + 3);
	var path = url.indexOf('/');
	if (path != -1) {
		url = url.substring(path);
	} else {
		var query = url.indexOf('?');
		if (query != -1)
			url = "/" + url.substring(query);
	}
	return url;
}
